module.exports = __webpack_public_path__ + "1edb668d7248851d28e536e65f2faaae.svg";